import React from 'react'
import { BANKING_BOTTOM_CONTENT, DESIGN_COURSE_PAGE_1, DESIGN_DETAILS_PAGE_1, DESIGN_HERO_PAGE_1 } from '../../../utils/constants'
import CourseCard from '../../../reusable/Course-card'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import { DESIGN_ACCORDIAN_1 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'

const DesignPage_1 = () => {
  return (
    <div className='outlet-render'>
    <CourseAsideHero  {...DESIGN_HERO_PAGE_1}/>
     <CoursesAside {...DESIGN_COURSE_PAGE_1}/>
     <CourseCard {...DESIGN_DETAILS_PAGE_1}/>
     <Accordian {...DESIGN_ACCORDIAN_1}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
   </div>
  )
}

export default DesignPage_1